import { render, staticRenderFns } from "./TeamMembersSlider.vue?vue&type=template&id=135fd6e2&"
import script from "./TeamMembersSlider.vue?vue&type=script&lang=js&"
export * from "./TeamMembersSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports